module.exports = __webpack_public_path__ + "static/media/owner-add.f8abd9b5.svg";